import { PayloadGroupMockup } from '../../../../../../../components/Forms/constants';
import { fieldNamesForServerFactory } from '../../../../../../../helpers/fieldNamesForServerFactory';

import { TransitDocumentFieldName } from './types';

const payloadTransitGroupName = 'path';

export const transitDocumentDataPayloadGroupMockup: PayloadGroupMockup<typeof payloadTransitGroupName> = {
  [payloadTransitGroupName]: {
    fromCountry: null,
    toCountry: null,
    returnCountry: null,
    transitCountry: [],
    customs: null,
  },
};

export const transitDocumentDataFieldNamesForServer = fieldNamesForServerFactory({
  groupName: payloadTransitGroupName,
  fields: [
    {
      localFieldName: TransitDocumentFieldName.toCountry,
      serverFieldName: 'toCountry',
    },
    {
      localFieldName: TransitDocumentFieldName.fromCountry,
      serverFieldName: 'fromCountry',
    },
    {
      localFieldName: TransitDocumentFieldName.returnCountry,
      serverFieldName: 'returnCountry',
    },
    {
      localFieldName: TransitDocumentFieldName.customs,
      serverFieldName: 'customs',
    },
  ],
});

const payloadPermitGroupName = 'permit';

export const transitPermitDocumentDataPayloadGroupMockup: PayloadGroupMockup<typeof payloadPermitGroupName> = {
  [payloadPermitGroupName]: {
    expiredAt: null,
    purpose: null,
  },
};

export const transitPermitDocumentDataFieldNamesForServer = fieldNamesForServerFactory({
  groupName: payloadPermitGroupName,
  fields: [
    {
      localFieldName: TransitDocumentFieldName.permitExpiredAt,
      serverFieldName: 'expiredAt',
    },
    {
      localFieldName: TransitDocumentFieldName.purpose,
      serverFieldName: 'purpose',
    },
  ],
});

export const minDate = new Date();
minDate.setDate(minDate.getDate() + 1);

export const maxDate = new Date();
maxDate.setDate(maxDate.getDate() + 90);

export const maxAdditionalCountry = 4;
